module.exports = new __parcel__URL__("logo-off-white.cdd8f6b5.png").toString();